import { FC } from 'react'
import IconFile from 'assets/file-icon.svg?react'
import cn from 'classnames'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import IconErrorWarning from 'remixicon/icons/System/error-warning-line.svg?react'

import { OrderDocumentsBlockProps } from './types'

import s from './styles.module.less'

export const OrderDocumentsBlock: FC<OrderDocumentsBlockProps> = (props) => {
  const {
    isLoading,
    isDocumentAssignmentLoading,
    isDocumentInvoiceLoading,
    barcode,
    serialId,
    docAssignment,
    docInvoice,
    isShowFullInfo = true,
    access
  } = props

  const handleDownloadAssignment = () => {
    if (!isDocumentAssignmentLoading && docAssignment) {
      const { blob } = docAssignment
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Поручение экспедитору по заявке №${serialId}`
      link.click()
      URL.revokeObjectURL(url)
    }
  }

  const handleDownloadInvoice = () => {
    if (!isDocumentInvoiceLoading && docInvoice) {
      const { blob } = docInvoice
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Счёт на оплату №${barcode}`
      link.click()
      URL.revokeObjectURL(url)
    }
  }

  return (
    <div className={cn(s.orderDocumentsBlock, 'mt-2')} data-test-id="order--documents--block">
      {!isLoading || !isDocumentAssignmentLoading ? (
        <a download className={s.downloadLink} onClick={handleDownloadAssignment}>
          <IconFile size="xs" />
          <span>Поручение экспедитору</span>
        </a>
      ) : (
        <PlaceholderCell className="!w-1/2 min-w-20" height={25} />
      )}
    </div>
  )
}
